import { groupedAtom } from '@/atoms/feed'
import { getPinBuryState } from '@/atoms/pinBury'
import { useAtomValue } from 'jotai'
import { HugeiconsIcon } from '@hugeicons/react'
import { PinIcon, ArrowDown01Icon } from '@hugeicons/core-free-icons'
import { useTranslation } from 'react-i18next'

export default function PinBuryBadge({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const grouped = useAtomValue(groupedAtom)

  const state = getPinBuryState(pubkey)

  // Only show badge when grouped notes is enabled
  if (!grouped) return null
  if (!state) return null

  if (state === 'pinned') {
    return (
      <div className="rounded-full bg-muted px-2 py-0.5 flex items-center" title={t('Pinned')}>
        <HugeiconsIcon icon={PinIcon} className="!size-3" />
      </div>
    )
  }

  if (state === 'buried') {
    return (
      <div className="rounded-full bg-muted px-2 py-0.5 flex items-center" title={t('Buried')}>
        <HugeiconsIcon icon={ArrowDown01Icon} className="!size-3" />
      </div>
    )
  }

  return null
}
